import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {useFeatureFlagStore} from '@/stores/featureFlagStore';

export async function beforeEnterFavoriteSeatsPage(
    _to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const featureAllowed = await useFeatureFlagStore().favoriteSeatsPage.isReady();

    if (!featureAllowed) {
        return {name: 'Home'};
    }
}
